import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {Store} from '@ngxs/store';
import {AuthActions} from '../state/auth/auth.actions';
import {mapTo} from 'rxjs/operators';

@Injectable()
export class ConfigResolver {
    constructor(protected store: Store) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        return this.store.dispatch(new AuthActions.GetConfiguration()).pipe(mapTo(null));
    }
}
